// Debug utility for hours calculation
export const debugHoursCalculation = (weeklyRoutes, crews, crewId, dayOfWeek) => {
  console.log('=== HOURS CALCULATION DEBUG ===');
  console.log('Crew ID:', crewId);
  console.log('Day of Week:', dayOfWeek);
  
  // Find the route for this day
  const dayRoute = weeklyRoutes.find(r => r.day === dayOfWeek);
  if (!dayRoute) {
    console.log('❌ No routes found for', dayOfWeek);
    return;
  }
  
  // Find the crew's route
  const crewRoute = dayRoute.routes.find(r => r.crewId === crewId);
  if (!crewRoute) {
    console.log('❌ No route found for crew', crewId, 'on', dayOfWeek);
    return;
  }
  
  console.log('✅ Found crew route:', {
    crewId: crewRoute.crewId,
    crewName: crewRoute.crewName,
    stopsCount: crewRoute.stops?.length || 0,
    totalServiceTime: crewRoute.totalServiceTime,
    totalDriveTime: crewRoute.totalDriveTime,
    totalMilesDriven: crewRoute.totalMilesDriven
  });
  
  // Calculate hours from minutes
  const serviceHours = (crewRoute.totalServiceTime || 0) / 60;
  const driveHours = (crewRoute.totalDriveTime || 0) / 60;
  const totalHours = serviceHours + driveHours;
  
  console.log('Calculated Hours:', {
    serviceHours: serviceHours.toFixed(2),
    driveHours: driveHours.toFixed(2),
    totalHours: totalHours.toFixed(2)
  });
  
  // Detail each stop
  if (crewRoute.stops?.length > 0) {
    console.log('Stop Details:');
    let manualServiceTotal = 0;
    crewRoute.stops.forEach((stop, index) => {
      console.log(`  Stop ${index + 1}:`, {
        name: stop.name,
        estimatedHours: stop.estimatedHours,
        serviceMinutes: (stop.estimatedHours || 0) * 60
      });
      manualServiceTotal += (stop.estimatedHours || 0) * 60;
    });
    
    console.log('Manual Service Total (minutes):', manualServiceTotal);
    console.log('Route Service Total (minutes):', crewRoute.totalServiceTime);
    
    if (Math.abs(manualServiceTotal - crewRoute.totalServiceTime) > 1) {
      console.warn('⚠️ Service time mismatch!', {
        manual: manualServiceTotal,
        route: crewRoute.totalServiceTime,
        difference: manualServiceTotal - crewRoute.totalServiceTime
      });
    }
  }
  
  console.log('=== END DEBUG ===\n');
  
  return {
    serviceHours,
    driveHours,
    totalHours,
    raw: crewRoute
  };
};

export const debugWeeklyHours = (weeklyHours, crewId) => {
  console.log('=== WEEKLY HOURS DEBUG ===');
  console.log('Crew ID:', crewId);
  
  const crewHours = weeklyHours[crewId];
  if (!crewHours) {
    console.log('❌ No hours data for crew', crewId);
    return;
  }
  
  console.log('Weekly Hours Data:', crewHours);
  
  // Check each day
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  days.forEach(day => {
    const dayData = crewHours[day];
    if (dayData) {
      console.log(`${day}:`, {
        serviceTime: dayData.serviceTime?.toFixed(2),
        driveTime: dayData.driveTime?.toFixed(2),
        total: ((dayData.serviceTime || 0) + (dayData.driveTime || 0)).toFixed(2)
      });
    }
  });
  
  console.log('Week Total:', {
    serviceTime: crewHours.total?.serviceTime?.toFixed(2),
    driveTime: crewHours.total?.driveTime?.toFixed(2),
    total: ((crewHours.total?.serviceTime || 0) + (crewHours.total?.driveTime || 0)).toFixed(2)
  });
  
  console.log('=== END WEEKLY DEBUG ===\n');
};

export const compareCalculationMethods = (weeklyRoutes, weeklyHours, crewId, dayOfWeek) => {
  console.log('=== COMPARING CALCULATION METHODS ===');
  
  // Method 1: From weeklyRoutes
  const routeCalc = debugHoursCalculation(weeklyRoutes, [], crewId, dayOfWeek);
  
  // Method 2: From weeklyHours
  const hoursData = weeklyHours[crewId]?.[dayOfWeek];
  const hoursCalc = hoursData ? {
    serviceHours: hoursData.serviceTime || 0,
    driveHours: hoursData.driveTime || 0,
    totalHours: (hoursData.serviceTime || 0) + (hoursData.driveTime || 0)
  } : null;
  
  console.log('Route Calculation:', routeCalc ? {
    service: routeCalc.serviceHours.toFixed(2),
    drive: routeCalc.driveHours.toFixed(2),
    total: routeCalc.totalHours.toFixed(2)
  } : 'N/A');
  
  console.log('WeeklyHours Calculation:', hoursCalc ? {
    service: hoursCalc.serviceHours.toFixed(2),
    drive: hoursCalc.driveHours.toFixed(2),
    total: hoursCalc.totalHours.toFixed(2)
  } : 'N/A');
  
  if (routeCalc && hoursCalc) {
    const diff = Math.abs(routeCalc.totalHours - hoursCalc.totalHours);
    if (diff > 0.01) {
      console.warn('⚠️ MISMATCH DETECTED!', {
        difference: diff.toFixed(2),
        routeTotal: routeCalc.totalHours.toFixed(2),
        hoursTotal: hoursCalc.totalHours.toFixed(2)
      });
    } else {
      console.log('✅ Calculations match');
    }
  }
  
  console.log('=== END COMPARISON ===\n');
};